import {useEffect, useMemo, useState} from 'react';
import {useSelecteSubscription} from '@src/Store/selectors/useMember';
import {auth} from '@src/firebase';
import {isMtnHostname} from '@src/Configs/mtnConfig';

/**
 * Detect MTN carrier user via subscription carrier, Firebase claims,
 * or gh-mtn.trace.plus hostname. Works even when subscription has expired.
 */
export const useIsMtnUser = (): boolean => {
  const memberSubscription = useSelecteSubscription();
  const [claimCarrier, setClaimCarrier] = useState<string | undefined>();

  useEffect(() => {
    const user = auth.currentUser;
    if (user) {
      user
        .getIdTokenResult(false)
        .then(result => {
          setClaimCarrier(result.claims?.carrier as string | undefined);
        })
        .catch(() => {});
    }
  }, [auth.currentUser?.uid]);

  return useMemo(() => {
    if (memberSubscription?.carrier === 'mtn') return true;
    if (claimCarrier === 'mtn') return true;
    if (isMtnHostname()) return true;
    return false;
  }, [memberSubscription?.carrier, claimCarrier]);
};

export default useIsMtnUser;
